// The app shell: a navy brand rail (desktop) and the content stage (all sizes).
// On mobile the rail collapses to a compact wordmark header.
// Implements: architecture.md v1.0 (Numaco brand navy/teal, marks in public/).

import type { JSX, ReactNode } from 'react';

export function BrandShell({
  children,
  lede,
  sub,
}: {
  children: ReactNode;
  lede?: string;
  sub?: string;
}): JSX.Element {
  return (
    <div className="shell">
      <aside className="brand-rail" aria-hidden="true">
        <div className="rail-top">
          <div className="rail-logo">
            <img src="/numaco_monogram.png" alt="" />
            <span>Numaco</span>
          </div>
          <p className="rail-lede">{lede ?? 'Find a time that works for both of us.'}</p>
          <p className="rail-sub">
            {sub ??
              'Live availability across our calendars. Pick a slot and you will get a calendar invite straight away.'}
          </p>
        </div>
        <p className="rail-foot">Numaco AG · Meet</p>
      </aside>

      <main className="stage">
        <div className="mobile-brand">
          {/* The full wordmark already carries the blue monogram, so we render it
              alone; a second standalone monogram beside it would show the mark
              twice in two colours. */}
          <img className="wm" src="/numaco_wordmark.png" alt="Numaco" />
        </div>
        {/* The brand rail above is decorative (aria-hidden) and hidden entirely
            on mobile, so the page-context lede/sub would never reach assistive
            tech. Surface the same orientation here, visually hidden, on every
            viewport. */}
        <p className="sr-only">
          {lede ?? 'Find a time that works for both of us.'}{' '}
          {sub ??
            'Live availability across our calendars. Pick a slot and you will get a calendar invite straight away.'}
        </p>
        {children}
      </main>
    </div>
  );
}
